import React from "react";
import { CCard, CCardBody, CCol, CRow } from "@coreui/react";

const durationLabels = {
  "<15": "< 15 Menit",
  "15-30": "15 - 30 Menit",
  ">30": "> 30 Menit",
};

function DurationCards({ groupedData, currentFilter, onClick }) {
  const order = ["<15", "15-30", ">30"];

  return (
    <CRow className="mb-3">
      {order.map((key) => {
        const count = groupedData.find((d) => d.durationGroup === key)?.count || 0;
        const active = currentFilter === key;

        return (
          <CCol md={4} key={key}>
            <CCard
              onClick={() => onClick(key)}
              style={{
                cursor: "pointer",
                backgroundColor: active ? "#d9edf7" : "#fff",
                border: active ? "2px solid #31708f" : "1px solid #ccc",
                transition: "all 0.2s",
              }}
            >
              <CCardBody>
                <h5 style={{ marginBottom: "4px" }}>{durationLabels[key]}</h5>
                <p style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>{count} kunjungan</p>
              </CCardBody>
            </CCard>
          </CCol>
        );
      })}
    </CRow>
  );
}

export default DurationCards;
